import { BASE_API_URL } from "../../config/Api";
import { ADD_CLIENT, ADD_NOTICE, CLIENT_DATA, CLIENT_DETAILS, NOTICE_DATA, NOTICE_DETAILS } from "./ActionType";

export const addClientDetails=(formData,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/addClientDetails`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(formData),
        })
        const resData=await res.json();
        if (res.ok) {
            dispatch({ type: ADD_CLIENT, payload: resData });
            return resData;
        } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
        }
    } catch (error) {
         console.error("Error:", error);
    }
}

export const fetchClientDetails=(token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/fetchClientDetails`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:CLIENT_DETAILS, payload:resData})
    } catch (error) {
        
    }
}

export const fetchClientData = (clientMasterId, token) => async (dispatch) => {
    try {
      const res = await fetch(
        `${BASE_API_URL}/fetchClientDataById?clientMasterId=${clientMasterId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const resData = await res.json();
      dispatch({ type: CLIENT_DATA, payload: resData });
    } catch (error) {}
  };

  export const fetchNoticeData = (noticeId, token) => async (dispatch) => {
    try {
      const res = await fetch(
        `${BASE_API_URL}/fetchNoticeDataById?noticeId=${noticeId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const resData = await res.json();
      dispatch({ type: NOTICE_DATA, payload: resData });
    } catch (error) {}
  };

  export const addNoticeDetails=(formData,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/addNoticeDetails`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(formData),
        })
        const resData=await res.json();
        if (res.ok) {
            dispatch({ type: ADD_NOTICE, payload: resData });
            return resData;
        } else {
            throw new Error(resData.statusDesc || 'Unknown error occurred');
        }
    } catch (error) {
         console.error("Error:", error);
    }
}

export const fetchNoticeDetails=(token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/fetchNoticeDetails`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:NOTICE_DETAILS, payload:resData})
    } catch (error) {
        
    }
}